import React from 'react';
export function CTAButton() {
  return <a href="https://thegliserastore.com/products/zenseat%E2%84%A2" target="_blank" rel="noopener noreferrer" className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg text-xl transition-all transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-300" data-id="element-10">
      GET PROFESSIONAL DRIVER PRICING - 50% OFF
    </a>;
}